import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';

import { Container, Grid, MenuItem, Paper } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';

import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    OverdraftSelectAll as OVERDRAFT_SELECT_ALL,
    Update as OVERDRAFT_UPDATE,
    Delete as OVERDRAFT_DELETE,
    Activate as OVERDRAFT_ACTIVATE
} from 'Components/Api/OverdraftApi';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import { Select as USERTYPE_SELECT } from 'Components/Api/UserTypeApi';
import ReactTable from 'Components/ReactTable/ReactTable';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const OverdraftSetting = () => {
    const classes = commonStyle();
    const [itemList, setItemList] = useState([]);
    const [userTypeList, setUserTypeList] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const selectUserTypes = async () => {
        const { isAuthorized, status, data } = await USERTYPE_SELECT();

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setSeverity('error');
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        var usertypedata = JSON.parse(data);
        setUserTypeList(usertypedata);
    };

    const selectData = async (UserTypeID) => {
        var jsonObj = {
            UserTypeID: UserTypeID
        };
        var request = JSON.stringify(jsonObj);

        const response = await OVERDRAFT_SELECT_ALL(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        var data = JSON.parse(response.data);

        setItemList(data);
    };
    const UpdateClick = async (row) => {
        let jsonObj = {
            OverdraftMasterID: row[0],
            MaxOverdraft: row[3]
        };

        var request = JSON.stringify(jsonObj);

        setIsError(false);
        setLoadingOpen(true);
        const response = await OVERDRAFT_UPDATE(request);

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) setSeverity('error');

        selectData(0);
    };
    const Delete = async (request) => {
        var jsonReq = JSON.stringify(request);
        setLoadingOpen(true);
        const response = await OVERDRAFT_DELETE(jsonReq);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) setSeverity('error');

        selectData(0);
    };

    const activate = async (item, value) => {
        var jsonObj = {
            OverdraftMasterID: item,
            IsActive: value
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoadingOpen(true);
        const response = await OVERDRAFT_ACTIVATE(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) setSeverity('error');

        selectData(0);
    };

    const onDeleteClick = (item) => {
        var RequestObj = { OverdraftMasterID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const createColumns = () => {
        var columns = [];
        columns.push({
            label: 'OverdraftMasterID',
            name: 'OverdraftMasterID',
            hide: true
        });
        columns.push({
            label: '#',
            name: '',
            srno: true
        });

        columns.push({
            label: 'User',
            name: 'FirmName',
            deactived: true
        });

        columns.push({
            label: 'MaxOverdraft',
            name: 'MaxOverdraft',
            editable: true
        });

        columns.push({
            label: 'Overdraft',
            name: 'Overdraft'
        });

        columns.push({
            label: 'Active',
            name: 'IsActive',
            activate: true,
            primaryKeyIndex: 0,
            callback: (id, value) => {
                activate(id, value);
            }
        });
        columns.push({
            label: 'Update',
            name: 'Update',
            save: true,
            buttonTitle: 'Update',
            callback: (row) => {
                UpdateClick(row);
            }
        });
        columns.push({
            label: 'Delete',
            name: 'OverdraftMasterID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });
        columns.push({
            label: 'IsActive',
            name: 'IsActive',
            hide: true
        });

        setMainColumns(columns);
    };

    useEffect(() => {
        setLoadingOpen(true);
        selectUserTypes();
        createColumns();
        selectData(0);
    }, []);

    const [formObject, setFormObject] = useState({
        ServiceID: 0,
        ServiceName: '',
        Charge: 0,
        MinBalance: 0
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        // if (loadingOpen) {
        //     setLoadingOpen(false);
        //     return;
        // }
        // var requestObj = JSON.stringify(values);
        // setSubmitting(false);
        // setIsError(false);
        // setLoadingOpen(true);
        // var response = await SERVICE_UPDATE(requestObj);
        // setLoadingOpen(false);
        // if (!response.isAuthorized) LOGOUT();
        // setIsError(true);
        // setSubmitting(true);
        // setSeverity('success');
        // setResponseMessage(response.data);
        // if (!response.status) {
        //     setSeverity('error');
        //     return;
        // }
        // setIsUpdate(false);
        // resetForm(formObject);
        // setFormObject({
        //     ServiceID: 0,
        //     ServiceName: '',
        //     Charge: 0,
        //     MinBalance: 0
        // });
        // setTimeout(() => {
        //     selectData();
        // }, MESSAGE_CLOSE_AFTER);
    };

    const OnRoleChange = async (name, value, setFieldValue) => {
        var UserTypeID = value; //event.target.value;

        setFieldValue(name, value);
        selectData(UserTypeID);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <Paper
                                style={{ marginBottom: 10 }}
                                className={classes.PaperStyle}
                            >
                                <h2 className={classes.PaperHead_h2}>
                                    Overdraft
                                </h2>

                                <Grid item xs={12}>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialSelect
                                            label="Role"
                                            name="UserTypeID"
                                            onCustomCallback={(name, value) => {
                                                OnRoleChange(
                                                    name,
                                                    value,
                                                    setFieldValue
                                                );
                                            }}
                                            title="Role"
                                        >
                                            <MenuItem key="0" value="0">
                                                Select Role
                                            </MenuItem>
                                            {userTypeList.map(
                                                (
                                                    { UserTypeID, UserType },
                                                    index
                                                ) => (
                                                    <MenuItem
                                                        key={index}
                                                        value={UserTypeID}
                                                    >
                                                        {UserType}
                                                    </MenuItem>
                                                )
                                            )}
                                        </MaterialSelect>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Form>
                    );
                }}
            />

            <ReactTable
                data={itemList}
                columns={mainColumns}
                rowsPerPage={100}
            />

            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete overdraft ."
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
